import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { FolderDocumentContains } from "./DocumentService";
import moment from "moment";

const DocumentViewFolder = () => {
  const { Id } = useParams();
  const [isLoading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [fileData, setFileData] = useState({});

  useEffect(() => {
    getFileData();
  }, []);

  async function getFileData() {
    setIsloading(true);
    const req = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: 0,
      Search: "",
      Id: 0,//Number(FolderId),
      GUID: Id,
      BookMarkedOnly: 0,
    };
    try {
      const responseData = await FolderDocumentContains(req);
      const data = responseData?.Data || [];

      setFileData(data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      // toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3 justify-content-center">
          <div className="col-xl-9">
            <div className="form-head d-flex flex-wrap align-items-center justify-content-between">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Documents File Detail</h2>
                <p>Know your colleague & find their contact information.</p>
              </div>
              {/* <div className="rightside-tabs">
                            <div class="dropdown documents-dropdown">
                              <button
                                    className="add-newticket me-2" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="bi bi-plus"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                    </svg>
                                    
                                  </button>
                               <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  <li><a class="dropdown-item" href="#">Create Folder</a></li>
                                  <li><a class="dropdown-item" href="#">Upload Documents</a></li>
                                  <li><a class="dropdown-item" href="#">Bulk Upload</a></li>
                                </ul>
                               
                                         </div>
                              </div> */}
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="row justify-content-center">
                <div className="col-xl-9">
                  <div className="card">
                    <div className="card-body">
                      <h4>
                        <b>{fileData[0]?.DocName}</b>
                      </h4>
                      <div className="file-modification mb-2">
                        <b>
                          {moment(fileData[0]?.ModifiedDate).format(
                            "DD-MM-YYYY hh:mm"
                          )}{" "}
                          by {fileData[0]?.ModifiedByName}
                        </b>
                      </div>

                      <iframe
                        className="d-block"
                        src={`${fileData[0]?.DocPath}`}
                        width="100%"
                        height="600px"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DocumentViewFolder;
